<template>
  <i-text-field
    :value="_fileName"
    v-bind="$attrs"
    @click="click"
    readonly
    :disabled="disabled"
    :prepend-icon="mdiPaperclip"
  >
    <template #append v-if="!disabled">
      <v-icon
        v-show="_fileName || !readonly"
        @click="$emit('clear')"
        color="#9ea5ad"
        :disabled="readonly"
        class="material-icons-outlined"
        >close</v-icon
      >

      <input
        v-show="false"
        type="file"
        ref="file"
        :accept="accept"
        :checkRequired="checkRequired"
        @change="onChange"
      />
    </template>
  </i-text-field>
</template>

<script>
// text-filed 형태 파일 인풋
import { mdiPaperclip } from '@mdi/js';
export default {
  props: {
    accept: {
      type: String,
      default: '',
    },
    value: {
      // v-model fileName
      type: String,
      default: '',
    },
    beforeChange: {
      // return '에러입니다'
      // 스트링 리턴시 에러로 취급  file change cancel
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: [String, Number], // mb 기준
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    checkRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileName: '',
      mdiPaperclip,
    };
  },
  computed: {
    files() {
      return this.$refs.file?.files;
    },
    file() {
      return this.$refs.file?.files[0];
    },
    _fileName: {
      get() {
        return this.value || this.fileName;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },

  methods: {
    onChange({ target }) {
      if (!target.files?.length) return;
      const errorMessage = this.beforeChange(target.files);
      if (typeof errorMessage === 'string') {
        return this.$showAlert({ title: '알림', message: errorMessage });
      }
      if (
        this.maxSize &&
        Array.from(target.files).some(
          file => file.size > this.maxSize * 1024 * 1024,
        )
      )
        return this.$showAlert({
          title: '알림',
          message:
            this.$t('업로드 가능한 최대 파일 용량은') +
            ` ${this.maxSize}` +
            this.$t('mb 입니다.'),
        });

      const fileName = Array.from(target.files)
        .map(v => v.name)
        .join();
      this.$emit('change:file', this.file);
      this._fileName = fileName;
      this.fileName = fileName;
    },
    click() {
      !this.readonly && this.$refs.file.click();
    },
    clear() {
      this.$refs.file.value = '';
      this._fileName = '';
      this.fileName = '';
    },
    hasFile() {
      const fileInput = this.$refs.file;
      return fileInput && fileInput.files.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped></style>
